export var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["Interface"] = 0] = "Interface";
    ResourceType[ResourceType["Volume"] = 1] = "Volume";
})(ResourceType || (ResourceType = {}));
export var ResourceCategory;
(function (ResourceCategory) {
    ResourceCategory[ResourceCategory["User"] = 1] = "User";
    ResourceCategory[ResourceCategory["System"] = 2] = "System";
    ResourceCategory[ResourceCategory["ManualTeardown"] = 4] = "ManualTeardown";
})(ResourceCategory || (ResourceCategory = {}));
export var ResourceState;
(function (ResourceState) {
    ResourceState["Waiting"] = "WAITING";
    ResourceState["Ready"] = "READY";
    ResourceState["Done"] = "DONE";
    ResourceState["Error"] = "ERROR";
})(ResourceState || (ResourceState = {}));
